import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {SharedModule} from '../../shared/shared.module';
import { CmsModule } from '../../cms/cms.module';

import { CustomPageComponent } from './custom-page.component';


const routes: Routes = [
  { path: '', component: CustomPageComponent},
  { 
    path: ':title',
    component: CustomPageComponent
  },
];

@NgModule({
  declarations: [CustomPageComponent],
  imports: [
    CmsModule,
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule,
    CustomPageComponent
  ]
  
})
export class CustomPageModule {
}
